module.exports = __webpack_public_path__ + "../resources/images/illustration_search-7fadd0d31bd384b9777b1c70ed03b93b.svg";